var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    {
      staticClass: "layout-invoice"
    },
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            {
              attrs: {
                text: _vm.text
              }
            },
            [
              _c(
                "gg-card-text",
                [
                  _c("gg-card-header", [_vm._v(" Transactional History ")]),
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.transaction_headers,
                      items: _vm.payments,
                      "items-per-page": _vm.itemsPerPage,
                      "hide-default-footer": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.net",
                        fn: function fn(_ref) {
                          var item = _ref.item
                          return [
                            _vm._v(
                              " " + _vm._s(_vm.moneyFormat(item.net)) + " "
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }